/*models/expressions/index*/
function _(require, module, exports) {
    var expression_1 = require(87    /* ./expression */);
    exports.Expression = expression_1.Expression;
    var stack_1 = require(89    /* ./stack */);
    exports.Stack = stack_1.Stack;    
}